import React, { useState, useEffect } from "react";
import { tools } from "../../constants/tools";
import ToolCard from "./ToolCard";
import { Modal, Button, SelectPicker } from "rsuite";
import useFilter from "../../hooks/useFilter";
import { lineofBusinessFilterData } from "../../constants/common";

const Home: React.FC = () => {
	const displayName = sessionStorage.getItem("name");
	const [showModal, setShowModal] = useState<boolean>(false);
	const { setSelectedFilter } = useFilter();

	useEffect(() => {
		const showModalFlag = sessionStorage.getItem("showModalFlag") || "true";
		if (showModalFlag === "true") {
			setShowModal(true);
			sessionStorage.setItem("showModalFlag", "false");
		}

		const handleBeforeUnload = () => {
			sessionStorage.setItem("showModalFlag", "true");
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

	const handleClose = () => {
		setShowModal(false);
	};

	const handleSubmit = () => {
		setShowModal(false);
	};

	return (
		<div className="h-full overflow-clip flex flex-col">
			{showModal && (
				<Modal
					backdrop={true}
					open={showModal}
					onClose={handleClose}
					size="sm"
				>
					<Modal.Header>
						<Modal.Title className="mb-5 text-[1vw] font-semibold rs-modal-title">
							MarginBrain Line of Business
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p className="text-[0.8vw] font-semibold mb-2">
							Please Select a Filter
						</p>
						<SelectPicker
							data={lineofBusinessFilterData}
							placeholder="Select a filter"
							onChange={setSelectedFilter}
							style={{ width: 220 }}
						/>
					</Modal.Body>
					<Modal.Footer>
						<Button
							onClick={handleSubmit}
							appearance="primary"
							className="modal-yes-btn"
						>
							Submit
						</Button>
					</Modal.Footer>
				</Modal>
			)}
			<div className="flex w-full p-5 px-[2%] flex-col items-start bg-dashboard-gradient bg-center">
				<p className="text-white text-fs32 font-bold">
					Welcome,{" "}
					<span className="text-fs32 font-bold text-deloitteGreen">
						{displayName}
					</span>
				</p>
				<p className="text-[1.4vw] text-white">MarginBrain</p>
				<p className="text-white home-page-footer-subtitle">
					To provide customer-specific actionable insights & recommendation to improve Customer Profitability across pricing, strategic growth, and cost-to-serve.
				</p>
			</div>
			<div className="bg-lightWhite px-[2%] pb-0 h-full max-h-full overflow-hidden flex flex-col">
				<h2 className="home-page-alerts-footer leading-[2vw] font-normal text-black mt-[6vh] mb-[2vh]">
					Your MarginBrain Tools
				</h2>
				<div className="flex h-[60%]">
					<div className="grid grid-cols-4 gap-[10px] flex-wrap">
						{tools.map((tool) => (
							<ToolCard key={tool.id} {...tool} />
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
